import React, { useEffect, useState } from 'react';

const OlympusGridCheck: React.FC = () => {
  const [gridStatus, setGridStatus] = useState<'loading' | 'ok' | 'fail'>('loading');
  const [gridMessage, setGridMessage] = useState<string>('⌛ Pending check...');
  const [gridData, setGridData] = useState<any>(null);

  useEffect(() => {
    const checkGrid = async () => {
      try {
        const res = await fetch('https://app.olympus-grid.com/services/apexrest/og_node_beta_1/v1/portal/config?sObjectTypeName=Config'); // 🔑 update when Grid API path changes
        if (!res.ok) throw new Error(`Bad response: ${res.status} ${res.statusText}`);
        const data = await res.json();
        setGridStatus('ok');
        setGridData(data);
        setGridMessage(data.message || '✅ Connected');
      } catch (err: any) {
        setGridStatus('fail');
        setGridMessage(err.message || '❌ Error reaching Olympus-Grid');
      }
    };

    setGridStatus('loading');
    checkGrid();
  }, []);

  return (
    <div
      style={{
        marginTop: '2rem',
        padding: '1.5rem',
        backgroundColor: '#1c1c2b',
        borderRadius: '8px',
        maxWidth: '800px',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    >
      <h2 style={{ color: '#ffdd80', fontSize: '1.25rem', marginBottom: '1rem' }}>
        🏛️ Olympus-Grid Check
      </h2>

      <div
        style={{
          backgroundColor: '#111',
          border: '1px solid #444',
          borderRadius: '6px',
          padding: '1rem',
          fontFamily: 'ui-monospace, SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace',
          color: '#ccc',
          fontSize: '0.9rem',
          whiteSpace: 'pre-wrap',
        }}
      >
        <h3
          style={{
            color:
              gridStatus === 'loading'
                ? '#ffdd80'
                : gridStatus === 'ok'
                ? '#80ffb0'
                : '#ff6b6b',
            fontWeight: 'bold',
            marginBottom: '0.75rem',
          }}
        >
          {gridStatus === 'loading'
            ? '⌛ Connecting to Olympus-Grid...'
            : gridStatus === 'ok'
            ? '✅ Connected to Olympus-Grid'
            : '❌ Olympus-Grid not reachable'}
        </h3>

        {gridStatus === 'ok' && gridData && (
          <>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <div>
                <strong>Service:</strong> <code>Olympus-Grid</code>
              </div>
              <div>
                <strong>Message:</strong> <code>{gridData.message}</code>
              </div>
              <div>
                <strong>Timestamp:</strong>{' '}
                <code>{new Date(gridData.timestamp).toLocaleString()}</code>
              </div>
            </div>

            <div
              style={{
                marginTop: '2rem',
                backgroundColor: '#111',
                padding: '1rem',
                borderRadius: '6px',
                border: '1px solid #444',
                color: '#ccc',
                fontSize: '0.95rem',
              }}
            >
              <h3 style={{ color: '#ffdd80', marginBottom: '0.75rem' }}>🔮 Next Steps</h3>
              <ul style={{ paddingLeft: '1.25rem' }}>
                <li>Expose Grid modules (e.g. Chronos, Iris, Forge).</li>
                <li>Report tenant/temple owner configuration.</li>
                <li>Integrate with Odyssey-Press for admin workflows.</li>
              </ul>
            </div>
          </>
        )}

        {gridStatus === 'fail' && (
          <p style={{ color: '#ff6b6b' }}>{gridMessage}</p>
        )}
      </div>
    </div>
  );
};

export default OlympusGridCheck;
